export default __webpack_public_path__ + "static/media/Hero's Tunic.c2f773f3.jpg";